/**
 * NOTE: This is generated file any changes to it can be overwritten at some point
 */
import React from 'react';

import { createSvgIcon } from '../utils';

const ErrorIcon = /*#__PURE__*/ createSvgIcon(
  'ErrorIcon',
  {
    ltr: {
      large: ({ id }) => (
        <>
          <path
            d="M9.996 13.75c.21 0 .39-.072.535-.214a.714.714 0 00.219-.532.736.736 0 00-.214-.535.714.714 0 00-.532-.219.736.736 0 00-.535.214.714.714 0 00-.219.532c0 .21.071.39.214.535.143.146.32.219.532.219zm0-2.75c.21 0 .39-.072.535-.216a.72.72 0 00.219-.534v-3.5a.728.728 0 00-.214-.534.72.72 0 00-.532-.216.734.734 0 00-.535.216.72.72 0 00-.219.534v3.5c0 .213.071.39.214.534a.72.72 0 00.532.216zm-2.267 6a1.44 1.44 0 01-1.063-.438l-3.228-3.25a1.498 1.498 0 01-.324-.491A1.497 1.497 0 013 12.25V7.73a1.44 1.44 0 01.438-1.063l3.229-3.23A1.44 1.44 0 017.729 3h4.542a1.44 1.44 0 011.063.438l3.229 3.229A1.44 1.44 0 0117 7.729v4.542a1.438 1.438 0 01-.438 1.063l-3.25 3.229c-.14.139-.305.247-.491.323a1.497 1.497 0 01-.571.114H7.73z"
            fill="currentColor"
          />
        </>
      ),
    },
  },
  false
);

export default ErrorIcon;
